import { u as useT, q as useUiLocale, t as useChromeLangDir, v as useDiagnosticFormatter, p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
const _error = React__default.memo(function Error(props) {
  let { id, SVs, children } = useDoenetRenderer(props);
  const t = useT();
  const uiLocale = useUiLocale();
  const chromeLangDir = useChromeLangDir();
  const formatDiagnostic = useDiagnosticFormatter(t, uiLocale);
  let displayedMessage = null;
  if (SVs.showMessage) {
    let errorStyle = {
      backgroundColor: "var(--lightRed)",
      color: "var(--canvasText)",
      textAlign: "center",
      borderWidth: 3,
      borderStyle: "solid",
      borderColor: "var(--mainRed)"
    };
    const message = formatDiagnostic({
      message: SVs.message,
      code: SVs.code,
      args: SVs.args
    });
    let locationLine = null;
    if (SVs.rangeMessage) {
      locationLine = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx("em", { children: SVs.rangeArgs ? t(
          "error-found-at",
          SVs.rangeArgs,
          SVs.rangeMessage
        ) : SVs.rangeMessage })
      ] });
    }
    displayedMessage = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: errorStyle, ...chromeLangDir, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("b", { children: t("error-heading", void 0, "Error") }),
      ": ",
      message,
      locationLine
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id, children: [
    displayedMessage,
    children
  ] });
});
export {
  _error as default
};
